/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './gauge.component.scss.shim.ngstyle';
import * as i1 from '../../../../node_modules/bootstrap/dist/css/bootstrap.css.shim.ngstyle';
import * as i2 from '@angular/core';
import * as i3 from '../../../../../src/app/components/gauge/gauge.component';
const styles_GaugeComponent:any[] = [i0.styles,i1.styles];
export const RenderType_GaugeComponent:i2.RendererType2 = i2.ɵcrt({encapsulation:0,
    styles:styles_GaugeComponent,data:{}});
export function View_GaugeComponent_0(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[i2.ɵqud(402653184,1,{chartContainer:0}),(_l()(),i2.ɵeld(0,[[1,
      0],['gauge',1]],(null as any),0,'div',[['class','d3-chart']],(null as any),(null as any),
      (null as any),(null as any),(null as any)))],(null as any),(null as any));
}
export function View_GaugeComponent_Host_0(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵeld(0,(null as any),(null as any),1,'ixgauge',([] as any[]),
      (null as any),(null as any),(null as any),View_GaugeComponent_0,RenderType_GaugeComponent)),
      i2.ɵdid(114688,(null as any),0,i3.GaugeComponent,([] as any[]),(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const GaugeComponentNgFactory:i2.ComponentFactory<i3.GaugeComponent> = i2.ɵccf('ixgauge',
    i3.GaugeComponent,View_GaugeComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL2NvbXBvbmVudHMvZ2F1Z2UvZ2F1Z2UuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3NyYy91aS9zcmMvYXBwL2NvbXBvbmVudHMvZ2F1Z2UvZ2F1Z2UuY29tcG9uZW50LnRzIiwibmc6Ly8vc3JjL3VpL3NyYy9hcHAvY29tcG9uZW50cy9nYXVnZS9nYXVnZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3NyYy91aS9zcmMvYXBwL2NvbXBvbmVudHMvZ2F1Z2UvZ2F1Z2UuY29tcG9uZW50LnRzLkdhdWdlQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cImQzLWNoYXJ0XCIgI2dhdWdlPjwvZGl2PiIsIjxpeGdhdWdlPjwvaXhnYXVnZT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7OzREQ0FBO01BQUE7TUFBQTs7O29CQ0FBO01BQUE7YUFBQTtVQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./aot_output/src/app/components/gauge/gauge.component.ngfactory.ts